/**
 * @description 表格分页逻辑Hook
 * @date 2025-01-17
 * @author lv.chen
 */

import { useState, useEffect } from 'react';

import type { IPaginationChangeEvent, IPublicFeedbackParams } from '../types';

interface IUseTablePaginationParams {
  /** 反馈查询参数 */
  feedbackParams: IPublicFeedbackParams;
  /** 获取反馈历史数据的方法 */
  fetchTrueDataFeedbackHistory: (params: IPublicFeedbackParams) => Promise<void>;
}

interface IUseTablePaginationReturn {
  /** 当前页码 */
  pageIndex: number;
  /** 外部排序或数据源切换时重置当前页码 */
  setPageIndex: (pageIndex: number) => void;
  /** 分页变更处理函数 */
  handlePageChange: (event: IPaginationChangeEvent) => void;
}

/**
 * 表格分页逻辑Hook
 */
export default function useTablePagination(params: IUseTablePaginationParams): IUseTablePaginationReturn {
  const { feedbackParams, fetchTrueDataFeedbackHistory } = params;

  const [pageIndex, setPageIndex] = useState(1);

  /**
   * 处理分页变更
   */
  const handlePageChange = (event: IPaginationChangeEvent): void => {
    const newPageIndex = event?.pageIndex || 1;
    setPageIndex(newPageIndex);

    const requestParams: IPublicFeedbackParams = {
      ...feedbackParams,
      page: newPageIndex,
      page_size: event?.pageSize,
    };

    fetchTrueDataFeedbackHistory(requestParams);
  };

  /**
   * 同步外部传入的页码
   */
  useEffect(() => {
    setPageIndex(feedbackParams?.page || 1);
  }, [feedbackParams]);

  return {
    pageIndex,
    setPageIndex,
    handlePageChange,
  };
}
